// Example of SVG converted to js array, so it can be used with CIcon.
// the first argument is two last values of svg viewBox,
// the second argument is the SVG content stripped of SVG tags
export const logo2 = ['220 134', `
 <g>
  <title>ONE Logo</title>
  <text font-weight="bold" xml:space="preserve" text-anchor="start" font-family="'Arial'" font-size="100" id="svg_1" y="103" x="5" stroke-width="0" stroke="#000" style="fill:currentColor;">ONE</text>
 </g>	
`]
